import CalendarState from "./calendarState";
import {calendarActions, CalendarActions} from "./calendarState.types";
import {Next, SetTime, ChoosePackage, SetDate, SetGoal, SetPartner, SetServiceType} from "./actions";

export default CalendarState;
export {calendarActions, Next, SetGoal, SetServiceType, SetDate, SetTime, ChoosePackage, SetPartner};
export type {CalendarActions};
